import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'

interface Props {
    deps: CommonDeps
    blob: Blob | null
    render: (objectUrl: string | null) => React.ReactElement<unknown>
}

interface State {
    objectUrl: string
}

export function withObjectUrl(deps: Props['deps'], blob: Props['blob'], render: Props['render']) {
    return <WithObjectUrl deps={deps} blob={blob} render={render} />
}

export class WithObjectUrl extends React.Component<Props, State> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    public state: State = {
        objectUrl: null,
    }

    public componentDidMount() {
        this.createObjectURL()
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.blob !== prevProps.blob) {
            this.revokeObjectURL()
            this.createObjectURL()
        }
    }

    public componentWillUnmount() {
        this.revokeObjectURL()
    }

    private createObjectURL() {
        const objectUrl = this.props.blob != null ? URL.createObjectURL(this.props.blob) : null
        this.setState({ objectUrl })
    }

    private revokeObjectURL() {
        if (this.state.objectUrl != null) URL.revokeObjectURL(this.state.objectUrl)
    }

    public tryRender = (): React.ReactElement<unknown> => {
        return this.props.render(this.state.objectUrl)
    }
}
